import type { ReactElement } from 'react'
import type { ITemplateProps } from '~/types/template'

import BaseTemplate from '../Base'

import './styles.scss'

export const PickerPortraitTemplate = (props: ITemplateProps): ReactElement => {
  return <BaseTemplate {...props} className="picker" />
}

export const PickerLandscapeTemplate = (props: ITemplateProps): ReactElement => {
  return <BaseTemplate {...props} className="picker picker-landscape" />
}
